



















































































































import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class DashboardTemplate extends Vue {
  @Prop({default: true})
  isListDisplay: boolean;
}
